export default "__VITE_ASSET__Dz6ffMex__"